module.exports = __webpack_public_path__ + "static/media/file_icon_2.17bc3ab7.svg";